import { LOG_KINDS, FACILITY_STATUS, fmtDateTime } from "@/lib/constants";
import { Wrench, StickyNote, RefreshCw, CheckCircle2 } from "lucide-react";

const ICONS = { cambio_stato: RefreshCw, nota: StickyNote, segnalazione: Wrench };

export const LogItem = ({ log, facilityName, onToggleResolved }) => {
  const Icon = ICONS[log.kind] || StickyNote;
  const isIssue = log.kind === "segnalazione";
  return (
    <li data-testid={`log-item-${log.id}`} className="flex gap-3 px-5 py-3.5">
      <span className={`mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-full ${isIssue && !log.resolved ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600"}`}>
        <Icon className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-xs text-slate-500">
          <span className="font-semibold uppercase tracking-wider text-slate-700">{LOG_KINDS[log.kind]}</span>
          {log.status && <> → {FACILITY_STATUS[log.status]?.label}</>}
          {facilityName && <> · {facilityName}</>}
        </p>
        <p className={`mt-0.5 text-sm ${log.resolved ? "text-slate-400 line-through" : "text-slate-800"}`}>{log.message}</p>
        <p className="mt-1 font-mono text-[11px] text-slate-400">{log.author} · {fmtDateTime(log.created_at)}</p>
      </div>
      {isIssue && onToggleResolved && (
        <button
          type="button"
          onClick={() => onToggleResolved(log)}
          data-testid={`log-resolve-${log.id}`}
          className={`self-start flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold transition-colors ${log.resolved ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-slate-200 text-slate-600 hover:border-emerald-300 hover:text-emerald-700"}`}
        >
          <CheckCircle2 className="h-3.5 w-3.5" />{log.resolved ? "Risolta" : "Segna risolta"}
        </button>
      )}
    </li>
  );
};
